import Vue from "vue"
import VueRaven from "vue-raven"

Vue.use(VueRaven, {
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV || "production",
})
